



































































import {
    computed,
    defineComponent,
    ref,
} from '@vue/composition-api';
import {
    SbButton,
    SdsIcon,
    SbNotificationMessage,
} from '@superbet-group/web.lib.ui-components';
import {
    getConfig,
    DocumentType,
} from '@superbet-group/web.lib.config';

import {
    allowedFormatsByFilename,
    maxFileSize,
} from '@modules/shared/validators/forms';
import { getUploadedFile } from './getid/constants';
import { fileSizeHumanReadable } from './utils';
import { useIdCardUploader } from './useIdCardUploader';
import {
    ValidationError,
    isRequired,
} from '@superbet-group/web.lib.utilities';
import { RouteName } from '@src/app/router/constants/RouteName';
import {
    useVueRouter,
    useVuexStore,
    useI18n,
} from '@superbet-group/web.lib.vue-utilities';
import modalStore from '@store/modules/ui/shared/modal/modalIndex';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import router from '@app/router';

export default defineComponent({
    setup() {
        const shouldPreventRouteChange = ref(true);

        const modalModule = useVuexStore<typeof modalStore>('ui/modal');
        const closeModal = modalModule.action('closeModal');
        const setModal = modalModule.action('setModal');

        const { pushRoute } = useVueRouter();
        const { uploadIdCard } = useIdCardUploader();
        const { translate } = useI18n();
        const formError = ref('');
        const asyncErrors = ref({});
        const isLoading = ref(false);
        const fields = ref({
            file: {
                value: null as any,
                isErrorVisibleWhileTyping: true,
                validate: [
                    isRequired,
                    maxFileSize(
                        getConfig().documentUpload.fileSize,
                        getConfig().documentUpload.fileSizeHumanReadable,
                    ),
                    allowedFormatsByFilename(getConfig().app.user.idCardVerification.allowedFormats),
                ],
            },
        });

        fields.value.file.value = getUploadedFile();
        const changeDocument = () => {
            const fileInput = document.getElementById('file-upload') as HTMLInputElement;
            fileInput.click();
        };
        const onChange = (event: any, onValueChanged: any) => {
            fields.value.file.value = event.target.files[0];
            if (formError.value) {
                formError.value = '';
            }
            onValueChanged(event.target.files, 'file');
        };

        const onSubmit = async () => {
            isLoading.value = true;
            try {
                await uploadIdCard(fields.value.file.value);
                shouldPreventRouteChange.value = false;
                pushRoute({
                    name: RouteName.Account.IdentityVerification,
                    params: {
                        isPendingVisible: 'true',
                        documentTypePending: DocumentType.AdditionalDocument,
                    },
                });
            } catch (e) {
                if (e instanceof ValidationError) {
                    if (e.fieldErrors?.general) {
                        formError.value = e.fieldErrors.general.join('');
                    } else {
                        asyncErrors.value = e.fieldErrors;
                    }
                } else {
                    formError.value = translate('pam.uploadAddition.generalError');
                }
            }
            isLoading.value = false;
        };

        const changeDocumentTextKey = computed(() => fields.value.file.value ? 'pam.uploadAddition.changeDocument' : 'pam.uploadAddition.selectDocument');

        const removeRouteInterceptor = router.beforeEach((_to, _from, next) => {
            if (!shouldPreventRouteChange.value) {
                removeRouteInterceptor();
                next();
                return;
            }

            const continueNavigation = () => {
                removeRouteInterceptor();
                closeModal();
                next();
            };

            setModal({
                code: modalCodes.exitKyc,
                data: {
                    confirmLeave: continueNavigation,
                    documentType: DocumentType.AdditionalDocument,
                },
            });
        });

        return {
            fields,
            fileSizeHumanReadable,
            changeDocument,
            onChange,
            onSubmit,
            changeDocumentTextKey,
            asyncErrors,
            formError,
            isLoading,

        };
    },
    components: {
        SbButton,
        SdsIcon,
        SbNotificationMessage,
    },
});
